/* eslint-disable import/prefer-default-export */
import useSWR from "swr";
import { getAuditTypes } from "./audit-service";
import { AuditTypesResponse } from "./audit-types";

export const useAuditTypes = () => {
  const { data, error, isLoading } = useSWR<AuditTypesResponse>(
    "/audit/types",
    getAuditTypes,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );

  return { data, error, isLoading };
};
